import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import JoinRoom from "./pages/JoinRoom";
import CallRoom from "./pages/CallRoom";
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import MyMeetings from "./pages/MyMeetings";
import MobileDownload from "./pages/MobileDownload";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<JoinRoom />} />
              <Route path="/login" element={<Login />} />
              <Route path="/mobile" element={<MobileDownload />} />
              <Route path="/room/:roomId" element={<CallRoom />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/my-meetings"
                element={
                  <ProtectedRoute>
                    <MyMeetings />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
